import { useContext } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DEFAULT_FISCAL_YEAR_MONTH_NAME } from 'reporting-data/constants/dates';
import { getUseFiscalYear } from 'reporting-data/lib/fiscalYearUtils';
// @ts-expect-error Untyped import
import makeDateRangeByType from 'reporting-data/lib/makeDateRangeByType';
import { Text } from 'foundations-components/components/Text';
import { FiscalYearContext } from '../../PlatformReport/FiscalYearProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const dateFormat = 'll';
const getDateRangeValue = config => config.getIn(['filters', 'dateRange', 'value']);
export const shouldReportShowInlineDateRangeLabel = config => !!getDateRangeValue(config);
export const getDateRangeText = (config, useFiscalYear = false, fiscalYearMonthName = DEFAULT_FISCAL_YEAR_MONTH_NAME) => {
  const currentDateRange = getDateRangeValue(config).toJS();
  const {
    startDate,
    endDate
  } = makeDateRangeByType(Object.assign({}, currentDateRange), dateFormat, config.get('dataType'), useFiscalYear, fiscalYearMonthName);
  return startDate === endDate ? startDate : `${startDate} - ${endDate}`;
};
export const ReportDateRangeTooltipContent = ({
  config
}) => {
  const useFiscalYear = getUseFiscalYear(config);
  const fiscalYearMonthName = useContext(FiscalYearContext);
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "report-date-range-tooltip",
    children: [/*#__PURE__*/_jsx(Text, {
      "data-test-id": "inline-date-range-label",
      as: "h5",
      use: "on-dark",
      marginBlockEnd: "100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "settingLabels.dateRange.inlineLabel"
      })
    }), /*#__PURE__*/_jsx(Text, {
      color: "fill-surface-default",
      children: getDateRangeText(config, useFiscalYear, fiscalYearMonthName)
    })]
  });
};